














import { Header } from '@/pages/profile/components';

export default {
  name: 'ProfilePurchases',
  components: {
    Header,
  },
  data() {
    return {
      selectItems: [
        { text: 'На обучение', to: 'profile-purchases-event' },
        { text: 'На мероприятие', to: 'profile-purchases-activity' },
        { text: 'На новую программу', to: 'profile-purchases-new-event' },
      ],
    };
  },
};



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/views/purchases/Index.vue